// This is an action. File location /src/store/actions/songs.js
import * as SongsReguests from '../requests/songs'

export const FETCH_SONGS = 'FETCH_SONGS'
export const FETCH_SONGS_SUCCESS = 'FETCH_SONGS_SUCCESS'
export const FETCH_SONGS_FAILED = 'FETCH_SONGS_FAILED'
export const SEARCH_SONGS = 'SEARCH_SONGS'
export const UPDATED_SELECTED_LANGS = 'UPDATED_SELECTED_LANGS'
export const CLEAR_SONGS = "CLEAR_SONGS"

export const fetchSongs = (searchQuery, langsOverride = null) => {
    return async (dispatch, getState) => {
        try {
            dispatch({type: FETCH_SONGS})
            const { selectedLangs } = getState().songs;

            // Use langsOverride if provided (e.g. when called from updateSelectedLangs,
            // since Redux state may not have updated yet at time of call)
            let langs;
            if (langsOverride) {
                langs = langsOverride.map(l => l.code);
            } else if (selectedLangs.length > 0) {
                langs = selectedLangs.map(l => l.code);
            } else {
                langs = null; // First load — omit header so API returns default_lang
            }

            const data = await SongsReguests.fetchSongs(searchQuery, langs);

            // On first load, use default_lang from response to set initial selectedLangs
            if (!langsOverride && selectedLangs.length === 0 && data.default_lang && data.available_langs.length > 0) {
                const defaultLang = data.available_langs.find(l => l.code === data.default_lang);
                if (defaultLang) {
                    dispatch({ type: UPDATED_SELECTED_LANGS, langs: [defaultLang] });
                }
            }

            dispatch({
                type: FETCH_SONGS_SUCCESS,
                songs: data.songs,
                availableLangs: data.available_langs,
                // Pass the hymnforge version block through; may be null if not configured
                hymnforgeInfo: data.hymnforge ?? null,
            })
        } catch(err) {
            console.error('Error fetching songs:', err);
            dispatch({type: FETCH_SONGS_FAILED, error: err})
        }
    }
}

export const clearSongs = () => {
    return { type: CLEAR_SONGS }
}

export const searchSongs = searchKeyword => {
    return { type: SEARCH_SONGS, searchKeyword }
}

export const updateSelectedLangs = langs => {
    return async (dispatch) => {
        dispatch({ type: UPDATED_SELECTED_LANGS, langs });
        // Pass langs directly — don't rely on Redux state having updated yet
        dispatch(fetchSongs('', langs));
    }
}
